import './Datepicker.scss';

import { format, isValid } from 'date-fns';
import es from 'date-fns/locale/es';
import DatePicker from 'react-datepicker';

import { DatepickerProps } from '@/interfaces/DatePickerInterface/DatepickerInterface';

export default function Datepicker({
  openCalendarStartDate,
  setOpenCalendarStartDate,
  openCalendarEndDate,
  setOpenCalendarEndDate,
  startDatePicker,
  setStartDatePicker,
  endDatePicker,
  setEndDateInput,
  setEndDatePicker,
  setStartDateInput,
}: DatepickerProps) {
  const onChange = (dateValue: Date | null, type: 'start' | 'end') => {
    const dateFormatInput = dateValue
      && isValid(dateValue)
      && format(new Date(dateValue), 'yyyy-MM-dd');
    if (type === 'start') {
      setStartDatePicker(dateValue);
      setStartDateInput(dateFormatInput);
      setOpenCalendarStartDate(false);
      setOpenCalendarEndDate(true);
    } else {
      setEndDatePicker(dateValue);
      setEndDateInput(dateFormatInput);
      // setOpenCalendarEndDate(false);
    }
  };

  return (
    <div className="datepicker-wrapper">
      {openCalendarStartDate && (
        <DatePicker
          locale={es}
          onChange={(date) => onChange(date, 'start')}
          selected={startDatePicker}
          startDate={startDatePicker ?? undefined}
          endDate={endDatePicker ?? undefined}
          maxDate={new Date()}
          autoComplete="off"
          isClearable
          inline
        />
      )}
      {openCalendarEndDate && (
        <DatePicker
          locale={es}
          onSelect={(date) => onChange(date, 'end')}
          onChange={(date) => onChange(date, 'end')}
          selected={startDatePicker}
          startDate={startDatePicker ?? undefined}
          endDate={endDatePicker ?? undefined}
          maxDate={new Date()}
          autoComplete="off"
          isClearable
          inline
        />
      )}
    </div>
  );
}
